import { readOperand } from "@/lib/mapper/conditions";
import type { CellModule } from "@/modules/_shared/contract";

export const sourceModule: CellModule = {
  kind: "source",
  capability: "cell",
  name: "Copy a Column",
  tooltip: "Copy a column from your file, exactly as it is",
  description: "Copies one column straight into this column, with no changes. The column can come from your file (source) or the workbook's processed data.",
  category: "Basics",
  tags: ["column", "copy", "passthrough", "map"],
  icon: { kind: "lucide", name: "Columns3" },
  tone: "sky",
  defaultConfig: () => ({ kind: "source", column: "" }),
  resolve: (rule, { row, output }) => {
    if (rule.kind !== "source") return "";
    // readOperand handles bare source headers AND "out:Field" workbook refs.
    return readOperand(rule.column, row, output);
  },
  templateStrings: (rule) => {
    if (rule.kind !== "source") return [];
    const col = rule.column.trim();
    return col.startsWith("out:") ? [`{{${col}}}`] : [];
  },
};
